import { useListMyNotificationsQuery, useMarkNotificationsAsViewedMutation } from "../../autogen/bff-api";

export const useMarkAllNotificationsRead = () => {
  const { data } = useListMyNotificationsQuery({ unread: true });
  const [markAsViewed, { isLoading }] = useMarkNotificationsAsViewedMutation();
  const markAll = () => markAsViewed({ markNotificationsRequest: { all: true } }).unwrap();
  return { unreadCount: data?.notifications.length ?? 0, markAll, isMarking: isLoading };
};
